// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.TopNav_topNav__p5qiE {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0 1.25rem;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 2rem;
}
.TopNav_topNav_left__loGHk {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex: 1 1;
  gap: 0.5rem;
}
.TopNav_topNav_left_menu_icon__-m3xr {
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: background-color 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
.TopNav_topNav_left_menu_icon__-m3xr:hover {
  background-color: var(--surface-muted);
}
@media only screen and (max-width: 768px) {
  .TopNav_topNav_left_menu_icon__-m3xr {
    display: none;
  }
}
.TopNav_topNav_left_menu__p\\+UKO {
  display: none;
}
@media only screen and (max-width: 768px) {
  .TopNav_topNav_left_menu__p\\+UKO {
    display: block;
  }
}
.TopNav_topNav_right__x7-zU {
  flex: 1 1;
}

.TopNav_search_desktop_wrapper__cGMkx {
  flex: 1 1;
}
@media screen and (max-width: 975px) {
  .TopNav_search_desktop_wrapper__cGMkx {
    display: none;
  }
}

.TopNav_search_tablet_wrapper__m0B\\+U {
  flex: 1 1 500px;
  display: none;
}
@media screen and (max-width: 975px) {
  .TopNav_search_tablet_wrapper__m0B\\+U {
    display: block;
    margin: 0.5rem 0 0;
  }
}

html[dir=rtl] .TopNav_topNav_left_menu_icon__-m3xr {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/components/topnav/TopNav.module.scss","webpack://./src/scss/abstracts/_variables.scss","webpack://./src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,4CAAA;EACA,mBAAA;AAOF;AANE;EEPA,aAAA;EACA,mBFOgB;EENhB,2BFMwB;EACtB,eAAA;EACA,SAAA;EACA,WAAA;AAUJ;AARI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBCHc;EDId,gEAAA;AAUN;AATM;EACE,sCAAA;AAWR;AEtBE;EFCE;IAaI,aAAA;EAYN;AACF;AAVI;EACE,aAAA;AAYN;AE9BE;EFiBE;IAGI,cAAA;EAcN;AACF;AAVE;EACE,SAAA;AAYJ;;AATA;EACE,SAAA;AAYF;AAXE;EAFF;IAGI,aAAA;EAcF;AACF;;AAZA;EACE,eAAA;EACA,aAAA;AAeF;AAdE;EAHF;IAII,cAAA;IACA,kBAAA;EAiBF;AACF;;AAbE;EACE,yBAAA;AAgBJ","sourcesContent":["@use \"../../scss/abstracts/\" as *;\r\n\r\n.topNav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.75rem 0 1.25rem;\r\n  border-bottom: 1px solid var(--border-color);\r\n  margin-bottom: 2rem;\r\n  &_left {\r\n    @include flex(center, flex-start);\r\n    flex-wrap: wrap;\r\n    flex: 1;\r\n    gap: 0.5rem;\r\n\r\n    &_menu_icon {\r\n      cursor: pointer;\r\n      min-width: 44px;\r\n      min-height: 44px;\r\n      display: inline-flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: $smallBorderRadius;\r\n      transition: background-color $duration-fast $ease-out;\r\n      &:hover {\r\n        background-color: var(--surface-muted);\r\n      }\r\n      @include tablet {\r\n        display: none;\r\n      }\r\n    }\r\n    &_menu {\r\n      display: none;\r\n      @include tablet {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  &_right {\r\n    flex: 1;\r\n  }\r\n}\r\n.search_desktop_wrapper {\r\n  flex: 1;\r\n  @media screen and (max-width: 975px) {\r\n    display: none;\r\n  }\r\n}\r\n.search_tablet_wrapper {\r\n  flex: 1 1 500px;\r\n  display: none;\r\n  @media screen and (max-width: 975px) {\r\n    display: block;\r\n    margin: 0.5rem 0 0;\r\n  }\r\n}\r\n\r\nhtml[dir=\"rtl\"] {\r\n  .topNav_left_menu_icon {\r\n    transform: rotate(180deg);\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n","@use './variables' as *;\r\n\r\n@mixin flex($alignItem: center, $justifyContent: center) {\r\n  display: flex;\r\n  align-items: $alignItem;\r\n  justify-content: $justifyContent;\r\n}\r\n\r\n@mixin mobile {\r\n  @media only screen and (max-width: $mobile-width) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin tablet {\r\n  @media only screen and (max-width: $tablet-width) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topNav": `TopNav_topNav__p5qiE`,
	"topNav_left": `TopNav_topNav_left__loGHk`,
	"topNav_left_menu_icon": `TopNav_topNav_left_menu_icon__-m3xr`,
	"topNav_left_menu": `TopNav_topNav_left_menu__p+UKO`,
	"topNav_right": `TopNav_topNav_right__x7-zU`,
	"search_desktop_wrapper": `TopNav_search_desktop_wrapper__cGMkx`,
	"search_tablet_wrapper": `TopNav_search_tablet_wrapper__m0B+U`
};
export default ___CSS_LOADER_EXPORT___;
